/**
 * Default CDN URL for the GLB asset bundle (`beckhoff-xts-viewer-3d-assets`).
 *
 * Lives in its own leaf module so it can be imported directly by both
 * `<XtsViewer3D>` and the public `index.ts` barrel without going through
 * the barrel itself — pulling it through `../index.js` creates a circular
 * import (XtsViewer3D ↔ index.ts), which manifests at runtime as
 *   `Cannot access 'JSDELIVR_ASSETS_BASE_URL' before initialization`
 * because the const sits in the TDZ when XtsViewer3D's module body runs.
 *
 * Pinned to the assets package version this viewer build targets (see
 * ./assetsVersion.ts). The assets release line is decoupled from the
 * viewer release line — assets only publish a new version when GLB
 * geometry actually changes — so `viewer@x.y.z` does NOT generally
 * resolve to `assets@x.y.z`. The exact version is captured at viewer
 * build time so every install streams from a known-compatible GLB
 * release.
 */

import { ASSETS_VERSION } from './assetsVersion.js';

export const JSDELIVR_ASSETS_BASE_URL =
  `https://cdn.jsdelivr.net/npm/beckhoff-xts-viewer-3d-assets@${ASSETS_VERSION}/models` as const;
